import(/* webpackMode: "eager", webpackExports: ["SandpackProvider","SandpackLayout","SandpackFileExplorer","SandpackCodeEditor","SandpackPreview"] */ "/app/node_modules/@codesandbox/sandpack-react/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DocsContext"] */ "/app/src/app/[...slug]/DocsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/app/src/app/[...slug]/Menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/mdx/Code/Code.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/mdx/People/backer-badge.svg");
;
import(/* webpackMode: "eager", webpackExports: ["SandpackCodeViewer"] */ "/app/src/components/mdx/Sandpack/SandpackCodeViewer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/mdx/Toc/Toc.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Nav/NavCategoryCollapsible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Search/index.tsx");
